import React from "react";

import async from "../components/Async";

import {
  Home,
  Users,
  User,
  Codesandbox
} from "react-feather";

import { Analytics } from "@mui/icons-material";

// Home
const HomePage = async(() => import("../pages/home/Home"));

// Sulzer App
const MixerDesign = async(() => import("../pages/sulzer/mixers/MixerDesign"));
const MixerOrder = async(() => import("../pages/sulzer/mixers/order/MixerOrder"));
const MixerHome = async(() => import("../pages/sulzer/HomePage"));
const QuotePrint = async(() => import("../pages/sulzer/mixers/quote/QuotePrint"));

// Auth components
const SignInRedirect = async(() => import("../pages/auth/SignInRedirect"));
const SignUpRedirect = async(() => import("../pages/auth/SignUpRedirect"));
const AccountApprove = async(() => import("../pages/auth/AccountApprove"));
const AccountReject = async(() => import("../pages/auth/AccountReject"));
const AccountError = async(() => import("../pages/auth/AccountError"));
const SignUp = async(() => import("../pages/auth/SignUp"));
const Page404 = async(() => import("../pages/auth/Page404"));
const Page500 = async(() => import("../pages/auth/Page500"));

// Admin components
// Admin Dashboard
const AdminDashboard = async(() => import("../pages/admin/admin_dashboard"));
// Accounts
const AdminAccountEdit = async(() => import("../pages/admin/user_management/edit/AdminAccountEdit"));
const QuoteConfigEdit = async(() => import("../pages/admin/user_management/edit/AdminAccountQuoteConfig"));
const AdminUserManagement = async(() => import("../pages/admin/user_management/main"));
// Quotes
const AdminQuoteManagement = async(() => import("../pages/admin/quote_management/main"));
const QuoteConfirm = async(() => import("../pages/admin/quote_management/confirmView/QuoteConfirm"));
const QuoteView = async(() => import("../pages/admin/quote_management/confirmView/QuoteView"));

const homeRoutes = {
  id: "Landing",
  path: "/home",
  header: "Landing",
  icon: <Home />,
  component: HomePage,
  children: null
};

const sulzerRoutes = {
  id: "Home",
  path: "/",
  header: "Sulzer",
  icon: <Home />,
  component: MixerHome,
  children: null
};

const mixerQuoteRoutes = {
  id: "MixerQuote",
  path: "/mixers/design/:quoteid",
  component: MixerDesign,
  children: null
};

const mixerOrderRoutes = {
  id: "MixerOrder",
  path: "/mixers/order/:quoteid",
  component: MixerOrder,
  children: null
};

const printQuoteRoutes = {
  id: "PrintQuote",
  path: "/quote/:quoteid",
  component: QuotePrint,
  children: null
};

const mixerRoutes = {
  id: "Mixers",
  path: "/mixers",
  icon: <Codesandbox />,
  children: [
    {
      path: "/mixers/design/new",
      name: "Mixer Design",
      component: MixerDesign
    },
  ],
  component: null
};

const adminDashboardRoutes = {
  id: "Dashboard",
  path: "/admin",
  header: "Admin",
  icon: <Analytics />,
  component: AdminDashboard,
  children: null
};

const adminRoutes = {
  id: "Admin",
  path: "/admin",
  icon: <User />,
  children: [
    {
      path: "/admin/users",
      name: "User Management",
      component: AdminUserManagement
    },
    {
      path: "/admin/quotes",
      name: "Quote Management",
      component: AdminQuoteManagement
    },
  ],
  component: null
};

const accountAdminRoutes = {
  id: "AccountEdit",
  path: "/admin/account",
  children: [
    {
      path: "/admin/account/edit/:userid",
      name: "Account Edit",
      component: AdminAccountEdit
    },
    {
      path: "/admin/account/quoteconfig/:userid",
      name: "Account Quote Configuration",
      component: QuoteConfigEdit
    },
  ],
  component: null
};

const quoteAdminRoutes = {
  id: "QuoteEdit",
  path: "/admin/quotes",
  children: [
    {
      path: "/admin/quotes/confirm/:quoteid",
      name: "Quote Confirm",
      component: QuoteConfirm
    },
    {
      path: "/admin/quotes/:quoteid",
      name: "Quote View",
      component: QuoteView
    }
  ],
  component: null
};

const authRoutes = {
  id: "Auth",
  path: "/auth",
  icon: <Users />,
  children: [
    {
      path: "/auth/b2c/sign-in/redirect/",
      name: "B2C SignIn Redirect",
      component: SignInRedirect
    },
    {
      path: "/auth/b2c/sign-up/redirect/",
      name: "B2C Create Redirect",
      component: SignUpRedirect
    },
    {
      path: "/auth/sign-up",
      name: "Profile Setup",
      component: SignUp
    },
    {
      path: "/auth/account/approve",
      name: "Account Approval",
      component: AccountApprove
    },
    {
      path: "/auth/account/notapproved",
      name: "Account Not Approved",
      component: AccountReject
    },
    {
      path: "/auth/account/error",
      name: "Account Error",
      component: AccountError
    },
    {
      path: "/auth/404",
      name: "404 Page",
      component: Page404
    },
    {
      path: "/auth/500",
      name: "500 Page",
      component: Page500
    }
  ],
  component: null
};

// Routes using the Dashboard layout
export const dashboardLayoutRoutes = [
  sulzerRoutes,
  mixerQuoteRoutes,
  mixerOrderRoutes,
  mixerRoutes
];

// Routes using the Dashboard layout when admin
export const dashboardLayoutRoutesAdmin = [
  sulzerRoutes,
  mixerQuoteRoutes,
  mixerOrderRoutes,
  mixerRoutes,
  adminDashboardRoutes,
  adminRoutes,
  accountAdminRoutes,
  quoteAdminRoutes
];

// Routes using the Print layout
export const printLayoutRoutes = [printQuoteRoutes];

// Routes using the Auth layout
export const authLayoutRoutes = [authRoutes];

//Routes using the Landing layout
export const landingRoutes = [homeRoutes];

// Routes visible in the sidebar
export const sidebarRoutes = [
  sulzerRoutes,
  mixerRoutes,
];

// Routes visible in the sidebar when admin
export const sidebarRoutesAdmin = [
  sulzerRoutes,
  mixerRoutes,
  adminDashboardRoutes,
  adminRoutes,
];
